export default "__VITE_PUBLIC_ASSET__85aef80f__"